import React from 'react';
import Header from "../../components/Header/Header";
import { useDispatch, useSelector } from "react-redux";
import { getAdminByIdSagaAction, removeAdminByIdSagaAction } from "../../redux/sagaActions";
import AdminForm from "../../components/AdminForm/AdminForm";
import AdminsHeader from "../../components/PagesHeaders/AdminsHeader/AdminsHeader";

const Admins = () => {
    const dispatch = useDispatch();
    const admins = useSelector(state => state.admins);

    return (
        <>
           <Header component={ <AdminsHeader/> } />
           <AdminForm/>
           <div className="page">
               <div className="settings">
                   {
                       admins.map(elem => {
                           return (
                               <div className="setting" key={ elem.id }>
                                   <div className="controls">
                                       <i className="control control--edit" onClick={ () => {
                                           dispatch(getAdminByIdSagaAction({ id: elem.id }));
                                       } }/>
                                       <i className="control control--remove" onClick={ () => {
                                           if (window.confirm('Вы действительно хотите удалить администратора?')) {
                                               dispatch(removeAdminByIdSagaAction({ id: elem.id }));
                                           }
                                       } }/>
                                   </div>
                                   <div className="setting__caption">{ elem.name }</div>
                               </div>
                           );
                       })
                   }
               </div>
           </div>
        </>
    );
};

export default Admins;